import { render } from "./MainContentBanner.vue?vue&type=template&id=2bec19df&scoped=true"
import script from "./MainContentBanner.vue?vue&type=script&lang=js"
export * from "./MainContentBanner.vue?vue&type=script&lang=js"

import "./MainContentBanner.vue?vue&type=style&index=0&id=2bec19df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bec19df"]])

export default __exports__